<template>
  <video id="vimeo-video" ref="videoPlayer" autoplay class="video-js vjs-big-play-centered"></video>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  name: "VideoPlayer",
  props: {
    value: {
      type: Object,
      default() {
        return {};
      }
    },
    disableProgress: {
      default: false
    },
    isPreRoll: {
      default: false
    }
  },
  data() {
    return {
      player: null
    };
  },

  computed: {
    ...mapFields("app", {
      preRollEnded: "preRollEnded"
    }),
  },

  mounted() {
    this.setPlayer();
  },

  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },

  methods: {
    setPlayer(){
      this.player = videojs(
        this.$refs.videoPlayer,
        this.value,
        function onPlayerReady() {
          // console.log("onPlayerReady", this);
        }
      );
      if(this.disableProgress){
        this.player.controlBar.progressControl.disable();
      }

      if(this.isPreRoll){
        this.listenPlayerEndEvent();
      }
    },

    listenPlayerEndEvent(){
      var self = this;
      this.player.on("ended", function(){
        self.preRollEnded = true;
        self.$parent.$emit("preRollEnded")
      })
    }
  }
};
</script>
